import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ApplicationSuccess: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <CheckCircleIcon
            sx={{ fontSize: 60, color: 'success.main', mb: 2 }}
          />
          <Typography component="h1" variant="h4" gutterBottom>
            Application Submitted!
          </Typography>
          <Typography variant="body1" align="center" paragraph>
            Thank you for submitting your application. We have received it and will review it shortly.
            You will receive a confirmation email with further details.
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" paragraph>
            Our team will contact you regarding the next steps in the process. You may now close this page.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default ApplicationSuccess;
